module.exports = __webpack_public_path__ + "static/sport/bgi-pc.d41532b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cart/bgi-pc.jpg
// module id = voST
// module chunks = 0